export default __webpack_public_path__ + "static/white_logo-8c47fe1959b60330079fcb8afe48e7c3.png";